var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_4014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3184 21.6621C42.4148 22.1356 42.4655 22.6253 42.4655 23.127V24.5918H66.0007V21.6621H42.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5352 23.127C39.5352 20.7038 37.5638 18.7324 35.1406 18.7324H16V55.5488H24.8867V43.8301H57.1133V55.5488H66V27.5215H39.5352V23.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8164 67.2676H54.1836V46.7598H27.8164V67.2676ZM45.3945 58.4785H48.3242V61.4082H45.3945V58.4785ZM39.5352 58.4785H42.4648V61.4082H39.5352V58.4785ZM33.6758 52.6191H36.6055V61.4082H33.6758V52.6191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_4014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileName);
export default __webpack_public_path__ + "static/media/FileName.8cfbc59f4fde7cb9fa0b63d58271c5d7.svg";
export { ForwardRef as ReactComponent };